import { render, staticRenderFns } from "./ed-section-object.vue?vue&type=template&id=4fe0f078&scoped=true&"
import script from "./ed-section-object.ts?vue&type=script&lang=ts&"
export * from "./ed-section-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-section-object.scss?vue&type=style&index=0&id=4fe0f078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe0f078",
  null
  
)

export default component.exports